class Event {
  /*
   on 方法 把订阅者所要订阅的事件以及相应的回调函数 记录在 Event 对象的 _cbs 属性中
  */
 on(eventName,fn){
  if(typeof fn !== "function"){
    console.error("fn must be a function");
    return;
  }

  this._cbs = this._cbs || {};
  (this._cbs[eventName] = this._cbs[eventName] || []).push(fn);
 }

 /*
  emit 方法接收一个事件名称参数 在Event对象的 _cbs 属性中取出对应的数组，并逐个执行里面的回调函数
 */

 emit(eventName){
  this._cbs = this._cbs || {};
  let callbacks = this._cbs[eventName], args;
  if(callbacks){
    callbacks = callbacks.slice(0);
    args = [].slice.call(arguments,1);
    for(let i=0,len = callbacks.length;i<len;i++){
      callbacks[i].apply(null, args);
    }
  }
 }
 /*
  off 方法  接收事件名称和当初注册的回调函数做参数，在 Event 对象的 _cbs 属性中删除对应的回调函数
 */
 off(eventName, fn){
  this._cbs = this._cbs || {};
  if(!arguments.length){
    this._cbs = {};
    return;
  }

  let callbacks = this._cbs[eventName];
  if(!callbacks){
    return;
  }

  if(arguments.length === 1){
    delete this._cbs[eventName];
    return;
  }

  let cb;
  for(let i=0,len = callbacks.length;i<len;i++){
    cb = callbacks[i];
    if(cb === fn || cb.fn === fn){
      callbacks.splice(i,1);
      break;
    }
  }
  return;
 }
}

export default Event;
